import { english } from "./english";

export function lang(template: string, data: any): JSX.Element | string {
    return template.replace(/{\s*(\w+)\s*}/g, (match, key) => {
        return key in data ? data[key] : match
    });
}

export type Language = typeof english;